/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Set_Color_BlackInputs */



/**
* | output |
* | --- |
* | "Set Color Black" |
*
* @param {Shortcut_Keys_Name_Set_Color_BlackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_set_color_black = /** @type {((inputs?: Shortcut_Keys_Name_Set_Color_BlackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Set_Color_BlackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Set Color Black")
	if (locale === "de") return /** @type {LocalizedString} */ ("Set Color Black")
	if (locale === "it") return /** @type {LocalizedString} */ ("Set Color Black")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Set Color Black")
	if (locale === "es") return /** @type {LocalizedString} */ ("Set Color Black")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Set Color Black")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Set Color Black")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Set Color Black")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Set Color Black")
	return /** @type {LocalizedString} */ ("Set Color Black")
});